import { Injectable } from '@angular/core';
import { CLOCKIN_LINETYPE_OPTIONS } from '@shared/constants/dropdown.constant';
import { PortalSettingsService } from './portal-settings.service';
import { LineType } from '@shared/model/line-type.model';
import { MechanicFormData } from '@shared/model/mechanic-type-data.model';
import { JobFormData } from '@shared/model/job-type-data.model';

@Injectable({
  providedIn: 'root',
})
export class ClockInOutService {
  portalSettings: any;
  constructor(portalSettingsService: PortalSettingsService) {
    portalSettingsService.portalSettings$.subscribe(latestSettings => {
      this.portalSettings = latestSettings;
    });
  }

  public getEnabledLineTypes(isActiveTechnician: boolean): LineType[] {
    const enabledLineTypesInClockIn = this.portalSettings.EnabledLineTypesInClockIn.ConfigValue;
    let lineTypes = [];
    if (enabledLineTypesInClockIn != null) {
      const allLineTypes = CLOCKIN_LINETYPE_OPTIONS;
      const enabledLineTypesInClockInList = enabledLineTypesInClockIn.split(',');
      lineTypes = allLineTypes.filter(lineType => {
        const isEnabled: boolean = enabledLineTypesInClockInList.includes(lineType.Value);
        const isJob: boolean = lineType.Value == 'J';
        const isMechanical: boolean = lineType.Value == 'M';
        const isSMWorkOrder: boolean = lineType.Value == 'S' && isActiveTechnician;
        return isEnabled && (isJob || isSMWorkOrder || isMechanical);
      });
    }
    return lineTypes;
  }

  public updateMechanicFormData(formData: { [key: string]: any }, data: MechanicFormData): void {
    formData.selectedEMWorkOrder = data.selectedWorkOrder;
    formData.selectedEMWorkOrderItem = data.selectedWorkOrderItem;
    formData.selectedEquipment = data.selectedEquipment;
    formData.selectedEMCostCode = data.selectedCostCode;
    formData.isMechanicformValid = data.isValidForm;
  }

  public resetMechanicFormData(formData: { [key: string]: any }): void {
    formData.selectedEMWorkOrder = null;
    formData.selectedEMWorkOrderItem = null;
    formData.selectedEquipment = null;
    formData.selectedEMCostCode = null;
    formData.isMechanicformValid = false;
  }

  public updateJobFormData(formData: { [key: string]: any }, data: JobFormData): void {
    formData.selectedJob = data.selectedJob;
    formData.selectedPhase = data.selectedPhase;
    formData.selectedEquipment = data.selectedEquipment;
    formData.isJobFormValid = data.isValidForm;
  }

  public resetJobFormData(formData: { [key: string]: any }): void {
    formData.selectedJob = null;
    formData.selectedPhase = null;
    formData.selectedEquipment = null;
    formData.isJobFormValid = false;
  }
}
